import { ICollaboratorSchema } from "@wingspanhq/payments/dist/interfaces";
import {
  getCollaboratorCompany,
  getCollaboratorEmail
} from "../../query/payments/selectors";
import { getRedactedUserName } from "../../query/users/selectors";

const getCollaboratorName = (collaborator: ICollaboratorSchema) =>
  getCollaboratorCompany(collaborator) ||
  getRedactedUserName(collaborator.member.user) ||
  getCollaboratorEmail(collaborator);

export default getCollaboratorName;
